/* import __COLOCATED_TEMPLATE__ from './collapse-toggle.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();